import React from 'react';
import { Link, withRouter } from "react-router-dom";
import {
  Layout,
  Menu,
  Avatar,
  Badge,
  Dropdown,
  Tooltip,
} from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  UserOutlined,
  SwapOutlined,
  SoundOutlined,
  RightOutlined,
  QuestionCircleOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import Cookies from 'js-cookie';

import { connect } from 'react-redux';
import {
  setConfig,
  initHandler,
  ajaxViewHandler,
} from "../store/actions";

import Config from '../Config';
import debounce from 'lodash.debounce';
import { doLogout } from '../utils/sessionWS';

const { Header } = Layout;

/* ── Route → page title map ─────────────────────────────────── */
const ROUTE_TITLES = {
  '/admin':                                    { title: 'Dashboard',                        section: '' },
  '/admin/index':                              { title: 'Dashboard',                        section: '' },
  '/admin/profil':                             { title: 'Profil',                           section: '' },
  '/admin/negara':                             { title: 'Negara',                           section: 'Master' },
  '/admin/merek':                              { title: 'Merek',                            section: 'Master' },
  '/admin/tipe':                               { title: 'Tipe',                             section: 'Master' },
  '/admin/jenis-kendaraan':                    { title: 'Jenis Kendaraan',                  section: 'Master' },
  '/admin/bahan-bakar':                        { title: 'Bahan Bakar',                      section: 'Master' },
  '/admin/warna':                              { title: 'Warna',                            section: 'Master' },
  '/admin/warna-plat':                         { title: 'Warna Plat',                       section: 'Master' },
  '/admin/pekerjaan':                          { title: 'Pekerjaan',                        section: 'Master' },
  '/admin/kepemilikan':                        { title: 'Kepemilikan',                      section: 'Master' },
  '/admin/golongan':                           { title: 'Golongan',                         section: 'Jasa Raharja' },
  '/admin/fungsi':                             { title: 'Fungsi',                           section: 'Master' },
  '/admin/payment':                            { title: 'Payment',                          section: 'Master' },
  '/admin/layanan':                            { title: 'Layanan',                          section: 'Master' },
  '/admin/dealer':                             { title: 'Dealer',                           section: 'Master' },
  '/admin/kabupaten':                          { title: 'Kabupaten',                        section: 'Master' },
  '/admin/njkb':                               { title: 'NJKB',                             section: 'Master' },
  '/admin/njkb-import':                        { title: 'Import NJKB',                      section: 'Master' },
  '/admin/iwkbu':                              { title: 'Data IWKBU',                       section: 'Jasa Raharja' },
  '/admin/gudang-notice':                      { title: 'Gudang Notice',                    section: 'Master' },
  '/admin/tanda_tangan':                       { title: 'Tanda Tangan SKPD',                section: 'Master' },
  '/admin/tanda_tangan_laporan':               { title: 'Tanda Tangan Laporan',             section: 'Master' },
  '/admin/jabatan':                            { title: 'Jabatan',                          section: 'Pegawai' },
  '/admin/waktu-operasional':                  { title: 'Waktu Operasional',                section: 'Pegawai' },
  '/admin/upt':                                { title: 'UPT',                              section: 'Pegawai' },
  '/admin/bidang':                             { title: 'Bidang',                           section: 'Pegawai' },
  '/admin/pegawai':                            { title: 'Pegawai',                          section: 'Pegawai' },
  '/admin/pengaturan/diskon':                  { title: 'Diskon',                           section: 'Pengaturan' },
  '/admin/pengaturan/reward-tepat-waktu':      { title: 'Reward Tepat Waktu',               section: 'Pengaturan' },
  '/admin/pengaturan/hari-libur':              { title: 'Hari Libur',                       section: 'Pengaturan' },
  '/admin/pengaturan/umum':                    { title: 'Umum',                             section: 'Pengaturan' },
  '/admin/pengaturan/swdkllj':                 { title: 'SWDKLLJ',                          section: 'Pengaturan' },
  '/admin/pengaturan/admstnk':                 { title: 'Adm. STNK',                        section: 'Pengaturan' },
  '/admin/pengaturan/admtnkb':                 { title: 'Adm. TNKB',                        section: 'Pengaturan' },
  '/admin/pengaturan/denda-pkb':               { title: 'Denda PKB',                        section: 'Pengaturan' },
  '/admin/pengaturan/denda-swdkllj':           { title: 'Denda SWDKLLJ',                    section: 'Pengaturan' },
  '/admin/pengaturan/notice':                  { title: 'Notice',                           section: 'Pengaturan' },
  '/admin/pengaturan/printer':                 { title: 'Printer',                          section: 'Pengaturan' },
  '/admin/pengaturan/target-pendapatan':       { title: 'Target Pendapatan',                section: 'Pengaturan' },
  '/admin/informasi/informasi-kendaraan':      { title: 'Informasi Kendaraan',              section: 'Informasi' },
  '/admin/informasi/cari-kendaraan':           { title: 'Cari Kendaraan',                   section: 'Informasi' },
  '/admin/informasi/migrasi':                  { title: 'Migrasi',                          section: 'Informasi' },
  '/admin/transaksi/blokir':                   { title: 'Blokir',                           section: 'Transaksi' },
  '/admin/transaksi/pendaftaran-eri':          { title: 'Pendaftaran dari ERI',             section: 'Transaksi' },
  '/admin/transaksi/penetapan-biaya-eri':      { title: 'Penetapan ERI',                    section: 'Transaksi' },
  '/admin/transaksi/pendaftaran':              { title: 'Pendaftaran Lama',                 section: 'Transaksi' },
  '/admin/transaksi/penetapan-biaya':          { title: 'Penetapan',                        section: 'Transaksi' },
  '/admin/transaksi/pembayaran':               { title: 'Pembayaran',                       section: 'Transaksi' },
  '/admin/transaksi/surat-keterangan-fiskal':  { title: 'Surat Keterangan Fiskal',          section: 'Transaksi' },
  '/admin/transaksi/cancel-notice':            { title: 'Batal Notice',                     section: 'Transaksi' },
  '/admin/transaksi/histori-notice':           { title: 'Histori Notice',                   section: 'Transaksi' },
  '/admin/transaksi/koreksi-nomor-notice':     { title: 'Koreksi Nomor Notice',             section: 'Transaksi' },
  '/admin/transaksi/audit-notice-rusak':       { title: 'Audit Notice Rusak',               section: 'Transaksi' },
  '/admin/transaksi/jasaraharja':              { title: 'Transaksi JR',                     section: 'Jasa Raharja' },
  '/admin/transaksi/validasi-setoran':         { title: 'Validasi Setoran SWDKLLJ',         section: 'Jasa Raharja' },
  '/admin/transaksi/smdd':                     { title: 'SMDD',                             section: 'Jasa Raharja' },
  '/admin/transaksi/uji-silang':               { title: 'Cross Check SWDKLLJ',              section: 'Jasa Raharja' },
  '/admin/jasa-raharja/resend':                { title: 'Resend Jasa Raharja',              section: 'Jasa Raharja' },
  '/admin/activitylog/saya':                   { title: 'Log Aktivitas Saya',               section: 'Log Aktivitas' },
  '/admin/activitylog/kelola':                 { title: 'Log Aktivitas User',               section: 'Log Aktivitas' },
  '/admin/transaksi/iwkbu':                    { title: 'IWKBU',                            section: 'Transaksi' },
  '/admin/laporan/pnbp':                       { title: 'PNBP',                             section: 'Laporan' },
  '/admin/laporan/kasir':                      { title: 'Kasir',                            section: 'Laporan' },
  '/admin/laporan/teller':                     { title: 'Penerimaan Teller',                section: 'Laporan' },
  '/admin/laporan/perekening':                 { title: 'Perekening',                       section: 'Laporan' },
  '/admin/laporan/pemutihan':                  { title: 'Pemutihan',                        section: 'Laporan' },
  '/admin/laporan/cetak-stnk':                 { title: 'Cetak STNK',                       section: 'Laporan' },
  '/admin/laporan/bendahara-penerimaan':       { title: 'Bendahara Penerimaan',             section: 'Laporan' },
  '/admin/laporan/bendahara-pkb':              { title: 'Bendahara PKB & BBNKB',            section: 'Laporan' },
  '/admin/laporan/harian-pkb':                 { title: 'Penetapan PKB & BBNKB',            section: 'Laporan' },
  '/admin/laporan/penerimaan-pkb-warna':       { title: 'Penerimaan PKB Warna Plat',        section: 'Laporan' },
  '/admin/laporan/sum-32':                     { title: 'SUM 32',                           section: 'Laporan' },
  '/admin/laporan/sts-harian':                 { title: 'STS Harian',                       section: 'Laporan' },
  '/admin/laporan/swdkllj':                    { title: 'SWDKLLJ',                          section: 'Laporan' },
  '/admin/laporan/penyetoran-uang':            { title: 'Pengantar Penyetoran Uang',        section: 'Laporan' },
  '/admin/laporan/bbnkb-pkb':                  { title: 'Penerimaan BBNKB & PKB',           section: 'Laporan' },
  '/admin/laporan/notice':                     { title: 'Notice',                           section: 'Laporan' },
  '/admin/laporan/notice-rusak':               { title: 'Notice Rusak',                     section: 'Laporan' },
  '/admin/laporan/penggunaan-notice-rusak':    { title: 'Penggunaan Notice & Notice Rusak', section: 'Laporan' },
  '/admin/laporan/ba-batal-skpd':              { title: 'BA Batal SKPD',                    section: 'Laporan' },
  '/admin/analitik/proyeksi-potensi-pkb':      { title: 'Proyeksi Potensi PKB',             section: 'Analitik' },
  '/admin/analitik/tunggakan':                 { title: 'Tunggakan Kendaraan',              section: 'Analitik' },
  '/admin/analitik/list-tunggakan':            { title: 'List Tunggakan',                   section: 'Analitik' },
  '/admin/panduan':                            { title: 'Panduan Pengguna',                 section: '' },
  '/admin/panduan/edit':                       { title: 'Edit Panduan Pengguna',            section: '' },
};

function getPageInfo(pathname) {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  const match = Object.keys(ROUTE_TITLES)
    .sort((a, b) => b.length - a.length)
    .find(k => pathname.startsWith(k + '/'));
  return match ? ROUTE_TITLES[match] : { title: 'eSamsat', section: '' };
}

// const socket = new WebSocket(this.config.get_web_socket()+"/ws/cekLogin/");

class AdminHeader extends React.Component {
  config;

  constructor(props) {
    super(props);
    this.config = new Config();
		this.ws = null;
    this.user = Cookies.get(this.config.get_cookie_name() + "_username").split("_");

  }

  // UNSAFE_componentWillMount() {
  //   this.props.initHandler();
  //   // navigator.serviceWorker.removeEventListener("message", (message) => {});
  // }

  componentDidMount() {
    // navigator.serviceWorker.addEventListener("message", (message) => {
    //     console.log('refreshing_new_data');
    // });

    // // 1. Buka WebSocket
    // this.ws = new WebSocket(this.config.get_web_socket()+`/ws/cek-status/${this.user[2]}/?device_id=${localStorage.getItem("device_id")}`);

    // // 2. Siapkan debounce untuk heartbeat (1 menit sekali)
    // const sendHeartbeat = debounce(() => {
    //   if (this.ws.readyState == WebSocket.OPEN) {
    //     this.ws.send(JSON.stringify({ type: 'heartbeat', username: this.user[2], device_id: localStorage.getItem("device_id") }));
    //     console.log('heartbeat sent');
    //   }
    // }, 60_000, { leading: true, trailing: false });

    // // 3. Pasang listener user activity
    // const events = [
    //   'mousemove','mousedown','keydown',
    //   'touchstart','scroll','visibilitychange'
    // ];

    // const handleEvent = (e) => {
    //   if (e.type == 'visibilitychange' && document.hidden) return;
    //   sendHeartbeat();
    // };


    // // const handleEvent = (e) => {
    // //   if (e.type == 'visibilitychange' && document.hidden) return;
    // //   // resetTimer();
    // //   console.log('resetting timer due to event:', e.type);
    // // };

    // events.forEach(evt => window.addEventListener(evt, handleEvent));
    // // kirim satu heartbeat saat pertama kali mount
    // sendHeartbeat();

    // // 4. Cleanup
    // this.cleanup = () => {
    //   events.forEach(evt => window.removeEventListener(evt, handleEvent));
    //   this.ws.close();
    // };
    // resetTimer();  // inisialisasi
    // Heartbeat dikelola oleh AdminLayout via this.socket (satu koneksi WS saja)
    this.cleanup = () => {};
  }

  componentWillUnmount() {
    this.cleanup();
  }


  hide = () => {
    this.setState({
      visiblePopMenu: false,
    });
  };

  handleVisibleChange = visible => {
    this.setState({ visible });
  };

  toggle = () => {
    this.props.setConfig({
      collapsed: !this.props.collapsed
    });
  };

  handleMenuAtas = (e) => {
    if (e.key == 'Logout') {
      // Logout terpusat — pakai socket device milik AdminLayout (registry),
      // tidak lagi membuka WebSocket baru di sini.
      doLogout(this.props.setConfig);
    }
  };

  

  renderMobileHeader() {
    const { uptDipilih, jam_countdown, tutup_countdown, level_user,
            pengumumanBadgeCount, cancelNoticePendingCount,
            nama, pp, username } = this.props;
    const siteInfo = this.config.get_site_info();

    let statusColor = '#34d399';
    let statusLabel = '';
    if (uptDipilih && uptDipilih !== '') {
      const jc = jam_countdown || '';
      const tc = tutup_countdown;
      const akanTutup  = tc != null && tc >= -10 && tc <= 0;
      const sedangBuka = jc.includes('Jam') || jc.includes('detik');
      const sudahTutup = jc.trim() === 'Tutup';
      const belumBuka  = jc.toLowerCase().includes('buka');
      if (akanTutup || sudahTutup || belumBuka) statusColor = '#ff4d4f';
      else if (sedangBuka) statusColor = '#34d399';
      statusLabel = jc;
    }

    const totalBadge = (pengumumanBadgeCount || 0) + (cancelNoticePendingCount || 0);

    const iconBtn = {
      background: 'none', border: 'none', cursor: 'pointer',
      width: 32, height: 32, borderRadius: 8, padding: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    };

    return (
      <Header className="header collapsed" style={{ height: 56, minHeight: 56, display: 'flex', alignItems: 'center', padding: 0 }}>
        {/* Left: logo + nama app */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingLeft: 14, flexShrink: 0 }}>
          <img
            alt="logo"
            src={siteInfo.logo}
            style={{ height: 28, width: 'auto', objectFit: 'contain' }}
          />
          <span style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', letterSpacing: '-0.3px' }}>
            eSamsat
          </span>
        </div>

        {/* Right: UPT chip + ganti UPT + bell + avatar — semua sejajar */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 'auto', paddingRight: 14 }}>
          {/* UPT chip — tinggi 32px sama dengan tombol */}
          {uptDipilih && uptDipilih !== '' && (() => {
            const upt = JSON.parse(uptDipilih);
            return (
              <div style={{
                display: 'flex', alignItems: 'center', gap: 5, flexShrink: 1, minWidth: 0,
                height: 32, borderRadius: 8, padding: '0 10px',
                background: statusColor + '18',
                border: `1.5px solid ${statusColor}50`,
                maxWidth: 'min(150px, calc(100vw - 230px))',
              }}>
                <div style={{ width: 7, height: 7, borderRadius: '50%', background: statusColor, flexShrink: 0 }} />
                <span style={{
                  fontSize: 11, fontWeight: 700, color: '#0f2847',
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {upt.nama}
                </span>
              </div>
            );
          })()}

          {/* Ganti UPT */}
          {level_user == 2 && uptDipilih && uptDipilih !== '' && (
            <button
              onClick={() => this.props.setConfig({ showPindahUptModal: true })}
              title="Ganti UPT"
              style={{ ...iconBtn, border: '1.5px solid #d0dae8' }}
            >
              <SwapOutlined style={{ fontSize: 15, color: '#1e4d8a' }} />
            </button>
          )}

          {/* Notification bell */}
          <Badge count={totalBadge} size="small">
            <button
              onClick={() => this.props.setConfig({ openPengumumanPanel: true })}
              style={iconBtn}
            >
              <SoundOutlined style={{ fontSize: 18, color: '#1e4d8a' }} />
            </button>
          </Badge>

          {/* Bantuan / Panduan Pengguna */}
          <Link to="/admin/panduan" style={iconBtn}>
            <QuestionCircleOutlined style={{ fontSize: 18, color: '#1e4d8a' }} />
          </Link>

          {/* Log Aktivitas Saya - self-service, sama pola dgn Panduan di
              atas (bukan menu permission-gated, jadi di topbar bukan
              sidebar) - lihat diskusi rencana 2026-10-17. */}
          <Link to="/admin/activitylog/saya" style={iconBtn}>
            <HistoryOutlined style={{ fontSize: 18, color: '#1e4d8a' }} />
          </Link>

          {/* Avatar profil */}
          <Link to="/admin/profil" style={{ flexShrink: 0 }}>
            <Avatar
              size={32}
              src={pp && !pp.endsWith('user.png') ? pp : undefined}
              style={{ background: '#1e4d8a', fontSize: 12, display: 'block' }}
            >
              {(!pp || pp.endsWith('user.png'))
                ? (nama ? nama[0].toUpperCase() : <UserOutlined />)
                : null}
            </Avatar>
          </Link>
        </div>
      </Header>
    );
  }

  handleLogout = () => {
    doLogout(this.props.setConfig);
  }

  render() {
    if (this.props.isMobile) return this.renderMobileHeader();

    const {
      uptDipilih, jam_countdown, tutup_countdown, level_user,
      nama, pp, username, pengumumanBadgeCount, cancelNoticePendingCount,
      location,
    } = this.props;

    const pathname = location ? location.pathname : '';
    const pageInfo = getPageInfo(pathname);
    const totalBadge = (pengumumanBadgeCount || 0) + (cancelNoticePendingCount || 0);

    // UPT status
    let timerClass = 'upt-timer';
    let statusClass = '';
    if (uptDipilih && uptDipilih !== '') {
      const jc = jam_countdown || '';
      const tc = tutup_countdown;
      const akanTutup  = tc != null && tc >= -10 && tc <= 0;
      const sedangBuka = jc.includes('Jam') || jc.includes('detik');
      const belumBuka  = jc.toLowerCase().includes('buka');
      const sudahTutup = jc.trim() === 'Tutup';
      if (akanTutup)       { timerClass = 'upt-timer upt-timer-yellow'; statusClass = 'upt-yellow'; }
      else if (sedangBuka) { timerClass = 'upt-timer upt-timer-green';  statusClass = 'upt-green';  }
      else if (sudahTutup) { timerClass = 'upt-timer upt-timer-red';    statusClass = 'upt-red';    }
      else if (belumBuka)  { timerClass = 'upt-timer upt-timer-red';    statusClass = 'upt-red';    }
    }

    // User dropdown menu
    const userMenu = (
      <Menu onClick={({ key }) => key === 'logout' && this.handleLogout()}>
        <div style={{ padding: '12px 16px 8px', borderBottom: '1px solid #f0f0f0' }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847' }}>{nama || username}</div>
          <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>
            {level_user === 1 ? 'Super Admin' : level_user === 2 ? 'Admin UPT' : 'Petugas'}
          </div>
        </div>
        <Menu.Item key="profil" icon={<UserOutlined />}>
          <Link to="/admin/profil">Lihat Profil</Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="logout" icon={<LogoutOutlined />} danger>
          Keluar
        </Menu.Item>
      </Menu>
    );

    return (
      <Header className={this.props.collapsed ? 'header collapsed' : 'header'}
        style={{ display: 'flex', alignItems: 'center', padding: 0 }}
      >
        {/* Hamburger toggle */}
        {React.createElement(this.props.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
          className: 'trigger',
          onClick: this.toggle,
          style: { flexShrink: 0 },
        })}

        {/* Page title */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: 1 }}>
          {pageInfo.section && (
            <>
              <span style={{ fontSize: 13, color: '#9ca3af', fontWeight: 500, whiteSpace: 'nowrap' }}>
                {pageInfo.section}
              </span>
              <RightOutlined style={{ fontSize: 10, color: '#d1d5db' }} />
            </>
          )}
          <span style={{
            fontSize: 15, fontWeight: 700, color: '#0f2847',
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>
            {pageInfo.title}
          </span>
        </div>

        {/* Right side: UPT + Ganti UPT + Notif + User */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingRight: 20, flexShrink: 0 }}>
          {/* UPT status */}
          {uptDipilih && uptDipilih !== '' && (
            <div className="upt-header-group">
              <div className={`upt-aktif${statusClass ? ' ' + statusClass : ''}`}>
                <div className='upt-dot' />
                <div className='upt-text-group'>
                  <span className='upt-nama'>{JSON.parse(uptDipilih).nama}</span>
                  {jam_countdown && (
                    <>
                      <div className='upt-sep' />
                      <span className={timerClass}>{jam_countdown}</span>
                    </>
                  )}
                </div>
              </div>
              {level_user == 2 && (
                <div className="upt-ganti-btn" onClick={() => this.props.setConfig({ showPindahUptModal: true })}>
                  <SwapOutlined className="upt-ganti-icon" />
                  <span className="upt-ganti-nama">Ganti UPT</span>
                </div>
              )}
            </div>
          )}

          {/* Notification bell */}
          <Tooltip title="Papan Pengumuman">
            <Badge count={totalBadge} size="small">
              <button
                onClick={() => this.props.setConfig({ openPengumumanPanel: true })}
                style={{
                  background: 'none', border: '1.5px solid #eef1f6', borderRadius: 8,
                  cursor: 'pointer', width: 36, height: 36,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}
              >
                <SoundOutlined style={{ fontSize: 17, color: '#1e4d8a' }} />
              </button>
            </Badge>
          </Tooltip>

          {/* Bantuan / Panduan Pengguna */}
          <Tooltip title="Panduan Pengguna">
            <Link
              to="/admin/panduan"
              style={{
                background: 'none', border: '1.5px solid #eef1f6', borderRadius: 8,
                cursor: 'pointer', width: 36, height: 36,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              <QuestionCircleOutlined style={{ fontSize: 17, color: '#1e4d8a' }} />
            </Link>
          </Tooltip>

          {/* Log Aktivitas Saya - self-service, sama pola dgn Panduan di
              atas - lihat diskusi rencana 2026-10-17. */}
          <Tooltip title="Log Aktivitas Saya">
            <Link
              to="/admin/activitylog/saya"
              style={{
                background: 'none', border: '1.5px solid #eef1f6', borderRadius: 8,
                cursor: 'pointer', width: 36, height: 36,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              <HistoryOutlined style={{ fontSize: 17, color: '#1e4d8a' }} />
            </Link>
          </Tooltip>

          {/* User dropdown */}
          <Dropdown overlay={userMenu} trigger={['click']} placement="bottomRight">
            <div style={{
              display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer',
              padding: '4px 10px 4px 4px',
              border: '1.5px solid #eef1f6', borderRadius: 10,
              background: '#fafbfd',
              transition: 'all 0.15s',
            }}>
              <Avatar
                size={28}
                src={pp && !pp.endsWith('user.png') ? pp : undefined}
                style={{ background: '#1e4d8a', fontSize: 11 }}
              >
                {(!pp || pp.endsWith('user.png'))
                  ? (nama ? nama[0].toUpperCase() : <UserOutlined />)
                  : null}
              </Avatar>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#0f2847', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {nama || username}
              </span>
            </div>
          </Dropdown>
        </div>
      </Header>
    );
  }
}

const mapStateToProps = function (state) {
  return state.configReducers;
}

export default withRouter(connect(mapStateToProps, {
  initHandler,
  setConfig,
  ajaxViewHandler,
})(AdminHeader));